<script setup lang="ts">
import { CircleX } from 'lucide-vue-next';
import { type SSOServer } from '@types';

const props = defineProps<{
    servers: Array<SSOServer>;
}>();

const onClick = (server: SSOServer) => (window.location.href = server.location);
</script>

<template>
    <div class="flex flex-col gap-4">
        <div v-if="props.servers.length > 0" class="flex flex-col gap-4">
            <Button
                v-for="server in props.servers"
                :key="server.id"
                type="submit"
                :label="server.name"
                @click="onClick(server)" />
        </div>
        <div v-else class="flex flex-col items-center gap-4">
            <CircleX :size="48" class="text-red-500 dark:text-red-400" />
            <p class="text-center">
                {{ $t('error.noSingleSignOnServersAvailable') }}
            </p>
        </div>
    </div>
</template>
